import React from "react";
import {
  AllowanceBox,
  ContentBody,
  ContentHeading,
  ContentLayout,
  EmpRound,
} from "../../style";
import {
  Box,
  Col,
  Flex,
  Row,
  Typography,
} from "../../../ppui";
import { TbCalendarTime,  } from "react-icons/tb";

const EmPortalHoliday = () => {
  return (
    <>
      <ContentLayout>
        <ContentHeading>
          <Typography variant="h5" mb="0">
            Holiday
          </Typography>
        </ContentHeading>

        <ContentBody Padding>
          <Flex gap={20} direction={"column"}>
            <AllowanceBox>
              <Row alignItems="center">
                <Col xs={12}>
                  <Flex alignItems="center" gap={{ md: 20, lg: 40, xxl: 60 }}>
                    <Box>
                      <EmpRound>
                        <TbCalendarTime />
                      </EmpRound>
                    </Box>
                    <Box>
                      <Box className="label">Name</Box>
                      <Box>Republic</Box>
                    </Box>
                    <Box>
                      <Box className="label">Date</Box>
                      <Box className="value">26-01-2024</Box>
                    </Box>

                    <Box>
                      <Box className="label">Day</Box>
                      <Box className="value">Friday</Box>
                    </Box>
                  </Flex>
                </Col>       
              </Row>
            </AllowanceBox>
            <AllowanceBox>
              <Row alignItems="center">
                <Col xs={12}>
                  <Flex alignItems="center" gap={{ md: 20, lg: 40, xxl: 60 }}>
                    <Box>
                      <EmpRound>
                        <TbCalendarTime />
                      </EmpRound>
                    </Box>
                    <Box>
                      <Box className="label">Name</Box>
                      <Box>Good Friday</Box>
                    </Box>
                    <Box>
                      <Box className="label">Date</Box>
                      <Box className="value">01-03-2024</Box>
                    </Box>

                    <Box>
                      <Box className="label">Day</Box>
                      <Box className="value">Monday</Box>
                    </Box>
                  </Flex>
                </Col>
              </Row>
            </AllowanceBox>
          </Flex>
        </ContentBody>
      </ContentLayout>

    </>
  );
};

export default EmPortalHoliday;
